import React from 'react';
import ReactDOM from 'react-dom/client';
import 'animate.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'antd/dist/antd.min.css';
import './style/index.css'
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import App from './App';
import Portfolio from './sections/Portfolio';
import Navbar from './components/Navbar';
import Footer from './sections/Footer';
import {
  BrowserRouter,
  Routes,
  Route,
} from "react-router-dom";


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Navbar />
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/projects" element={<Portfolio />} />
      </Routes>
      <Footer />
    </BrowserRouter>
    <ToastContainer position='top-center' />

  </React.StrictMode>
);


